$(document).ready(function () {
  var $sidebarEl = $('.custom-sidebar-categories'),
    $container = $('.custom-collection-page-template');
  if ($sidebarEl.length && $container.length) {
    $container.append('<div class="page-sidebar"></div>');
    $sidebarEl.appendTo($container.find('.page-sidebar'));
    $container.append('<div class="page-content"></div>');
    $container.find('.page-content').append($container.children().not($container.find('.page-sidebar')));
  }
});

jQuery(document).ready(function() {
  
	$(function () {
	  $('.lazy').lazy({
	    effect: 'fadeIn',
	    effectTime: 500,
	    afterLoad: function (element) {
	      console.log(element.parent().parent().addClass('remove-height'));
	    }
	  });
	});

	$(function () {
	  $('.product-release-img img').lazy({
	    effect: 'fadeIn',
	    effectTime: 500,
	    afterLoad: function (element) {
	      console.log(element.parent().parent().addClass('remove-height'));
	    }
	  });
	});


	$('.custom-alert-block i').click(function () {
	  $('.custom-alert-block').hide();
	});


	$('.artist-slider-block').slick({
	  dots: false,
	  infinite: true,
	  autoplay: true,
	  autoplaySpeed: 4000,
	  speed: 500
	});

	jQuery(".navUser-item-search a.search-icon").click(function () {
	  jQuery("body").addClass("mobile-search-open");
	  jQuery(".navUser-item-search").toggleClass("active");
	});

	jQuery(".navUser-item-search a.search-close-icon").click(function () {
	  jQuery(".navUser-item-search").toggleClass("active");
	  jQuery("body").removeClass("mobile-search-open");
	});

  // Initialize the zoomycrosssell slider only upon window load
  $(window).on('load', function() {
    typeof jQuery('#zooomyCrossSell').slick === 'function' && jQuery('#zooomyCrossSell').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [{
          breakpoint: 1279,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    });
  });
}); // READY END
